import { Grid, Loader } from "@aws-amplify/ui-react";
import { CCard } from "@coreui/react";
import LocalizedStrings from "react-localization";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { API } from "aws-amplify";

import { serviceOrderMaintenanceRoutinesByServiceOrderId } from "graphql/queries";
import {
  createServiceOrderMaintenanceRoutine,
  deleteServiceOrderMaintenanceRoutine,
} from "graphql/mutations";
import SelectMaintenanceRoutine from "components/maintenanceRoutines/SelectMaintenanceRoutine";

const RoutinesCard = ({ serviceOrder }) => {
  const [initialRoutines, setInitialRoutines] = useState([]);
  const [loading, setLoading] = useState(false);

  const onChangeMaintenanceRoutines = async (maintenanceRoutines) => {
    try {
      setInitialRoutines(maintenanceRoutines);

      const promises = [];

      // Update maintenance routines
      const maintenanceRoutinesToUnLink = initialRoutines?.filter(
        (servMaintenanceRoutine) =>
          !maintenanceRoutines?.some(
            (maintenanceRoutine) =>
              maintenanceRoutine === servMaintenanceRoutine
          )
      );
      maintenanceRoutinesToUnLink?.forEach(async (maintenanceRoutineId) => {
        const records = (
          await API.graphql({
            query: serviceOrderMaintenanceRoutinesByServiceOrderId.replaceAll(
              "__typename",
              ""
            ),
            variables: {
              serviceOrderId: serviceOrder.id,
              filter: {
                and: [{ maintenanceRoutineId: { eq: maintenanceRoutineId } }],
              },
            },
          })
        )?.data?.serviceOrderMaintenanceRoutinesByServiceOrderId?.items;
        promises.push(
          API.graphql({
            query: deleteServiceOrderMaintenanceRoutine.replaceAll(
              "__typename",
              ""
            ),
            variables: {
              input: {
                id: records[0].id,
              },
            },
          })
        );
      });
      const maintenanceRoutinesToLink = maintenanceRoutines?.filter(
        (maintenanceRoutine) =>
          !initialRoutines?.some((rec) => rec === maintenanceRoutine)
      );
      maintenanceRoutinesToLink?.forEach((maintenanceRoutineId) => {
        promises.push(
          API.graphql({
            query: createServiceOrderMaintenanceRoutine.replaceAll(
              "__typename",
              ""
            ),
            variables: {
              input: {
                maintenanceRoutineId,
                serviceOrderId: serviceOrder.id,
              },
            },
          })
        );
      });

      await Promise.all(promises);
    } catch (err) {
      toast.error(strings.responses.errorRequest);
    }
  };

  const fetchRoutinesByService = async (serviceOrderId) => {
    try {
      setLoading(true);

      const records = (
        await API.graphql({
          query: serviceOrderMaintenanceRoutinesByServiceOrderId.replaceAll(
            "__typename",
            ""
          ),
          variables: {
            serviceOrderId,
          },
        })
      )?.data?.serviceOrderMaintenanceRoutinesByServiceOrderId?.items;

      setInitialRoutines(records?.map((r) => r.maintenanceRoutineId) ?? []);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (serviceOrder?.id) fetchRoutinesByService(serviceOrder.id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [serviceOrder?.id]);

  return (
    <CCard
      className="p-3"
      borderRadius="medium"
      variation="outlined"
      style={{ height: "100%" }}
    >
      <Grid gap="5px">
        <span className="fs-5 text-muted">{strings.routines.title}</span>
        {loading ? (
          <Loader />
        ) : (
          <SelectMaintenanceRoutine
            initialValues={initialRoutines}
            onChangeMaintenanceRoutines={onChangeMaintenanceRoutines}
            companyID={serviceOrder.companyID}
          />
        )}
      </Grid>
    </CCard>
  );
};

const strings = new LocalizedStrings({
  es: {
    routines: {
      title: "Rutinas de Mantenimiento",
    },
    responses: {
      errorFetch: "Error al consultar rutinas de mtto",
      errorRequest: "Error al realizar la petición",
    },
  },
});

export default RoutinesCard;
